import createOrders from '@exodus/orders';
import ordersPluginDefinition from './plugin.js';
const orders = (config) => {
    const { definitions } = createOrders(config);
    return {
        id: 'orders',
        definitions: [...definitions, { definition: ordersPluginDefinition }],
    };
};
export default orders;
